import { ApiUserData } from "src/models/user/ApiUserData"
import { BasePutInputModel } from "../../../../models/http/InputModel/BasePutInputModel"

export class MyPageUserPutInputModel extends BasePutInputModel {
  constructor(private params: Partial<ApiUserData>) {
    super()
  }

  get body(): Record<string, unknown> {
    // PUTのbodyとしてfavorite_genresはGenre[]ではなくnumber[]が求められているので変換。
    const favorite_genres =
      this.params.favorite_genres !== undefined &&
      this.params.favorite_genres.length > 0
        ? this.params.favorite_genres.map((v) => v.id)
        : []

    return {
      ...this.params,
      favorite_genres,
    }
  }
}
